/* import { Toast } from 'vant' 
getTokenData 
import {
  setTokenData
} from '@/utils'*/

import { feachSaleOrderList, postSaleOrderReceipt } from '@/api/queryBasedata'
import { getUserInfo } from '../../utils/auth'
 

export default {
  namespaced: true,
  state: {
    orderList: [],
    user: getUserInfo() || {}
  },
  mutations: {
    // [set_AssetData](state, data) {
    //   state.assetData = data
    //   setTokenData('assetData', data)
    // }
  },
  actions: {
    async getSaleOrderList({ state }, data) {
      return new Promise(async (reslove, reject) => {
        try {
          console.log(state)
          let result = await feachSaleOrderList(data)
          reslove(result)
        } catch (error) {
          /* Toast({
            message: error.message || '失败',
            position: 'middle',
            duration: 1500
          }) */
          reject(error)
        }
      })
    },
    async saleOrderReceipt({ state }, data) {
      return new Promise(async (reslove, reject) => {
        try {
          console.log(state)
          let result = await postSaleOrderReceipt(data)
          reslove(result)
        } catch (error) {
          /* Toast({
            message: error.message || '失败',
            position: 'middle',
            duration: 1500
          }) */
          reject(error)
        }
      })
    }
    
  },
  getters: {
    orderList(state) {
      return state.orderList
    }
  }
}
